import React from 'react';
import {IAfterActivateSlideRendererContext, IBeforeDeactivateSlideRendererContext,
    ISlideRenderer
} from "../video-slides.service.interface";
import {IVideoSwiperSlideController} from "../models/video-swiper-slide-controller.interface";
import {GameInfo} from "../../games/game-info";
import {VideoSlidesAnalyticsReporter} from "../analytics/video-slides-analytics-reporter";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {VideoTypeEnum} from "../../video/models/video-type.enum";
import {TimeSpan} from "@sparkware/app-utils";


export abstract class VideoSlideBaseRenderer implements ISlideRenderer {

    constructor(protected readonly gameInfo: GameInfo, protected readonly videoType: VideoTypeEnum, protected readonly services: IServiceFactoryExtended) {

    }

    protected abstract _renderVideoSlide(context: IVideoSwiperSlideController, uniqueKey: string): React.ReactElement;

    private _analyticsReporter: VideoSlidesAnalyticsReporter | null = null;


    render(context: IVideoSwiperSlideController): React.ReactElement {
        this._analyticsReporter = new VideoSlidesAnalyticsReporter(this.gameInfo, this.videoType, context, this.services);
        context.videoPlayer.attachAnalyticsReporter(this._analyticsReporter);
        return this._renderVideoSlide(context, `${this.gameInfo.gameType}_${context.itemIndex}`);
    }

    private _slideActivationTime: number = Date.now();
    onAfterActivated(context: IAfterActivateSlideRendererContext): void {
        this._slideActivationTime = Date.now();
        this._analyticsReporter?.reportSlideActivated(context.swipeDirection);
    }

    onBeforeDeactivate(context: IBeforeDeactivateSlideRendererContext): void {
        this._analyticsReporter?.reportSlideDeactivated({
            swipeDirection: context.swipeDirection,
            slideActiveTime: TimeSpan.fromMilliseconds( Date.now() - this._slideActivationTime)
        });
    }

    protected  _playGame = async () => {

        this._analyticsReporter?.reportPlayGame();

        await this.gameInfo.open({
            isRealMode: true
        });
    }

    protected _onBookGame = () => {
        this._analyticsReporter?.reportBookedGame();
    }

    protected _onRemoveBookedGame = () => {
        this._analyticsReporter?.reportRemoveBookedGame();
    }
}